import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import loadScript from 'load-script';

import {
  FullScreenOverlayBody,
  FullScreenOverlayHeader,
  FullScreenOverlayContent
} from '@bibliocommons/base-full-screen-overlay';
import { TableStencil } from '@bibliocommons/table';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import { BibBriefContainer } from 'app/components/bibs/shared/BibBrief';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';

import './NovelistOverlay.scss';

const NOVELIST_SCRIPT_SRC = 'https://imageserver.ebscohost.com/novelistselect/ns2init.js';

export default function NovelistOverlay({ catalogBib, isbn }) {
  const currentLibrary = useSelector(selectCurrentLibrary);
  const [isLoading, setIsLoading] = useState(false);

  const metadataId = catalogBib.get('metadataId');
  const novelistProfile = currentLibrary.getIn(['novelistParameters', 'profile']);
  const novelistPassword = currentLibrary.getIn(['novelistParameters', 'password']);

  useEffect(() => {
    function loadNovelistContent() {
      if (window.novSelect) {
        setIsLoading(true);
        window.novSelect.loadContentForQuery(
          {
            ClientIdentifier: isbn,
            ISBN: isbn,
            version: '2.3'
          },
          novelistProfile,
          novelistPassword,
          () => setIsLoading(false)
        );
      } else {
        loadScript(NOVELIST_SCRIPT_SRC, loadNovelistContent);
      }
    }

    loadNovelistContent();
  }, [isbn, novelistProfile, novelistPassword]);

  return (
    <FullScreenOverlayBody className="cp-novelist-overlay">
      <FullScreenOverlayHeader title={<FormattedMessage id="vendor_novelist" />} />
      <FullScreenOverlayContent size="medium">
        <BibBriefContainer metadataId={metadataId} />
        <div data-novelist-novelistselect={isbn} />
        {isLoading && <TableStencil />}
      </FullScreenOverlayContent>
    </FullScreenOverlayBody>
  );
}

NovelistOverlay.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  isbn: PropTypes.string.isRequired
};
